// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"da8a6783","23":"c9fb4f49","212":"eb715eb0","461":"6232ef78","551":"69760b3e","737":"bfe6d8a9","743":"3801184f","923":"31d6cfe0"}[chunkId] + ".chunk.css";
};